export default "__VITE_ASSET__BszJ0HN9__"